import {
  Button,
  ModalCategoryReceipt,
  Translator,
  enumsPayment,
  formatDate,
  useCampaignImage,
  Alert,
} from "@itarget/shared";
import {
  Box,
  Breadcrumbs,
  Container,
  Dialog,
  Divider,
  Grid,
  Hidden,
  Typography,
} from "@material-ui/core";

import CardOffers from "../../../components/CardOffers";
import CarouselCardOffers from "../../../components/CarouselCardOffers";
import Layout from "../../../components/Layout";
import TabsDetailOffer from "../../../components/TabsDetailOffer";
import LoginContainer from "../../login/LoginContainer";
import { useOfferRules } from "../../../hooks/useOfferRules";

import AdherenceCampaign from "../../../components/AdherenceCampaign";
import CardAlertNecessary from "../../../components/CardAlertNecessary";
import {
  ChipAccumulationCashback,
  ChipRedemptionCashback,
} from "../../../components/CardOffers/ChipCashback copy";
import CardWrongCreditCard from "../../../components/CardWrongCreditCard";
import DisplayValuesOffers from "../../../components/DisplayValues​Offers";
import Modal from "../../../components/Modal";
import { ModalQuestions } from "../../../components/ModalQuestionsCourse";
import { useStyles } from "./styles";

const DetailBreadcrumbs = ({ detailing, goTo }) => {
  const styles = useStyles();
  
  if (!detailing) return null;
  
  return (
    <Breadcrumbs className={styles.breadcrumbs} separator="›">
      <div
        onClick={() => goTo("")}
        onKeyDown={() => goTo("")}
        className={styles.breadcrumbLink}
      >
        <Translator transRef="translation.Ofertas" />
      </div>
      <div className={styles.breadcrumbCurrent}>
        {detailing.desc_atv || detailing.desc_tatv}
      </div>
    </Breadcrumbs>
  );
};

const DetailOfferView = ({
  alert,
  annuities,
  centerCost,
  isLoadingScreen,
  status_comprovante_categoria,
  comp_recusa,
  paymentRedux,
  toast,
  user,
  offer,
  tabs,
  value,
  handleChange,
  addShoppingCart,
  openLogin,
  handleCloseLogin,
  cc,
  center_cost_id,
  showWrongCard,
  changePayment,
  setShowWrongCard,
  redirectSubscribe,
  openModalReceipt,
  setOpenModalReceipt,
  id,
  selectOffer,
  selectProduct,
  goTo,
  detailErrorMessage,
  necessaryErrorMessage,
  setNecessaryErrorMessage,
  errorSubscriptionData,
  isLoading,
  isLoadingSubscribe,
  showQuiz,
  setShowQuiz,
  category,
  onChangeCategory,
  addWaitingList,
  activityAmount,
  totalAnnuity,
  actionStream,
  onClickMindsRadiology,
  onChangeComboAnnuity,
  handlePurchaseQuantity,
  total,
  currentCampaignOpened,
  openCampaignTerms,
  closeCampaignTerms,
  openAdherenceTerms,
  handleAdherenceCampaign,
  businessRules,
  settingCommerce,
}) => {
  const styles = useStyles();
  const { STATUS_REGISTRATION } = enumsPayment;

  const detailing = tabs?.detailing?.[0];
  
  const cashback = {
    data: detailing?.cashback || [],
    pagar_com_cashback: detailing?.pagar_com_cashback,
    percentual_cashback: detailing?.percentual_cashback,
  };

  const collectionFilteredByCampaignId = cashback.data.filter((campaign, index, array) => 
    index === array.findIndex(({ campanha_id }) => campaign.campanha_id === campanha_id) && 
    !campaign.adesoes_clientes_campanhas_aceite
  );

  const mindsRadiologyUrl = detailing?.ins_metadata 
    ? JSON.parse(detailing?.ins_metadata)?.mindsRadiologyUrl 
    : "";

  const startDate = detailing?.data_inicio_aga 
    ? formatDate.ptBr(detailing?.data_inicio_aga) 
    : "";

  const endDate = detailing?.data_fim_aga 
    ? formatDate.ptBr(detailing?.data_fim_aga) 
    : "";

  const soldOut = detailing?.vagas_limite <= detailing?.vagas_ocupadas;

  const canBuyMore = detailing?.qtd_inscricoes < detailing?.vagas_limite_insc_mesma_pessoa &&
                    detailing?.mais_insc_mesma_pessoa === "S";

  const vacancies = detailing?.vagas_limite - detailing?.vagas_ocupadas;

  const buyLimit = (() => {
    let limit = detailing?.vagas_limite_insc_mesma_pessoa - detailing?.qtd_inscricoes;
    return vacancies <= limit ? vacancies : limit;
  })();

  const freeAccess = !detailing?.plp_id && 
                    detailing?.status_inscricao === STATUS_REGISTRATION.REGISTERED;

  const hasPendingAnnuities = annuities.length > 0;

  const translation = {
    campaignTitle: Translator({
      transRef: "translation.Termos e regras da campanha",
    }).props.children,
  };

  const rules = useOfferRules({
    isLoadingScreen,
    detailing,
    user,
    category,
    annuities,
    totalAnnuity,
    soldOut,
    canBuyMore,
    hasPendingAnnuities,
    collectionFilteredByCampaignId,
    mindsRadiologyUrl,
    freeAccess,
    centerCost
  });

  const { getBannerImage } = useCampaignImage({
    data: currentCampaignOpened.campanhas_idiomas_imagem,
  });
  
  const campaignBanner = getBannerImage();
  const title = detailing?.desc_atv || detailing?.desc_tatv;

  return (
    <Layout isLoading={isLoadingScreen}>
      {showQuiz && (
        <ModalQuestions
          setShowQuiz={setShowQuiz}
          questionDestination={17}
          centerCostId={center_cost_id}
        />
      )}
      <Dialog
        maxWidth="lg"
        open={openLogin}
        onClose={handleCloseLogin}
        className="dialog-login"
      >
        <LoginContainer />
      </Dialog>
      {currentCampaignOpened && (
        <Modal
          image={campaignBanner}
          open={openAdherenceTerms}
          handleClose={closeCampaignTerms}
          title={translation.campaignTitle}
          className={styles.campaignTermsModal}
          description={currentCampaignOpened.campanhas_idiomas_termo}
          definition={currentCampaignOpened.campanhas_idiomas_descricao}
        />
      )}
      {showWrongCard && (
        <CardWrongCreditCard
          changePayment={changePayment}
          setShow={setShowWrongCard}
        />
      )}
      {necessaryErrorMessage && errorSubscriptionData && (
        <CardAlertNecessary
          card={offer}
          message={necessaryErrorMessage}
          setMessage={setNecessaryErrorMessage}
          errorSubscriptionData={errorSubscriptionData}
        />
      )}
      <Grid className="detailOffer-background">
        <Container maxWidth="xl">
          <DetailBreadcrumbs detailing={detailing} goTo={goTo} />
          <Hidden lgUp>
            {detailing && (
              <DisplayValuesOffers.Header
                title={title}
                axios={detailing?.desc_eixo}
              />
            )}
            <DisplayValuesOffers.Return
              onReturn={() =>
                goTo(
                  rules.configuredForDistanceLearning
                    ? "ead/"
                    : `offers-unique/${cc}`
                )
              }
            />
          </Hidden>
          {detailErrorMessage && (
            <Grid className="detailOffer-cardOffers">
              <Typography className="infos-error">
                {detailErrorMessage}
              </Typography>
              <Grid className="infos-button">
                <div
                  onClick={() => goTo("")}
                  onKeyDown={() => goTo("")}
                  className="infos-text"
                  role="button"
                >
                  <Translator transRef={"translation.Retornar."} />
                </div>
              </Grid>
            </Grid>
          )}

          <Grid container spacing={3} className="detailing-offer-container">
            <Grid className="grid-item" item lg={9} xs={12}>
              <Hidden mdDown>
                <Grid className="detailOffer-cardOffers">
                  <CardOffers card={offer} />
                </Grid>
              </Hidden>
              <TabsDetailOffer
                tabs={tabs}
                value={value}
                handleChange={handleChange}
                settingCommerce={settingCommerce}
              />
            </Grid>
            <Grid className="grid-item grid-cardPrice" item lg={3} xs={12}>
              {user && openModalReceipt && (
                <ModalCategoryReceipt
                  centerCostId={cc}
                  status_comprovante_categoria={status_comprovante_categoria}
                  comp_recusa={comp_recusa}
                  open={openModalReceipt}
                  setOpen={setOpenModalReceipt}
                  toast={toast}
                  payment={paymentRedux}
                />
              )}
              {alert.open && (
                <Box marginBottom={2}>
                  <Alert.Root>
                    <Alert.Container>
                      <Alert.Title icon="lock">
                        <Translator transRef="translation.Programa cashback bloqueado" />
                      </Alert.Title>
                      <Alert.Content>{alert.message}</Alert.Content>
                    </Alert.Container>
                  </Alert.Root>
                </Box>
              )}
              <Hidden mdDown>
                {detailing && (
                  <DisplayValuesOffers.Header
                    title={title}
                    activityType={detailing?.desc_tatv}
                  />
                )}
                <DisplayValuesOffers.Return
                  onReturn={() =>
                    goTo(
                      rules.configuredForDistanceLearning
                        ? "ead/"
                        : `offers-unique/${cc}`
                    )
                  }
                />
              </Hidden>
              <Hidden lgUp>
                <Grid className="detailOffer-cardOffers">
                  <CardOffers card={offer} />
                </Grid>
              </Hidden>
              {rules.requestCategory && (
                <DisplayValuesOffers.Root>
                  <DisplayValuesOffers.Category
                    categories={category?.data || []}
                    onConfirmCategory={onChangeCategory}
                  />
                </DisplayValuesOffers.Root>
              )}
              <Box>
                {rules.displayAdherenceTerms &&
                  !alert.open &&
                  collectionFilteredByCampaignId.map(
                    ({ campanha_id, campanhas_idiomas_descricao }, key) => {
                      const textKey = `adherence-term-${key}-campaign-${campanha_id}`;
                      return (
                        <AdherenceCampaign
                          key={textKey}
                          campaignId={campanha_id}
                          handleTerms={openCampaignTerms}
                          description={campanhas_idiomas_descricao}
                          handleAdherenceCampaign={handleAdherenceCampaign}
                        />
                      );
                    }
                  )}
              </Box>
              {rules.allowsDisplayOfferValues && (
                <DisplayValuesOffers.Root>
                  {(rules.allowsDisplayOfTheAmount ||
                    rules.allowsDisplayReference) && (
                    <Box className={styles.verticalGroup}>
                      {rules.allowsDisplayOfTheAmount && (
                        <DisplayValuesOffers.Amount
                          amount={activityAmount}
                          discount={{
                            discountedAmount:
                              rules.allowsDisplayDiscountedComboAnnuity &&
                              (totalAnnuity > 0
                                ? detailing?.valor_pacote ||
                                  detailing?.valor_socio_quite
                                : detailing?.valor_socio_quite),
                            type: "percentage",
                          }}
                        />
                      )}
                      {rules.allowsDisplayReference && (
                        <DisplayValuesOffers.Reference
                          category={
                            user?.data?.categoria_centro_custo_descricao
                          }
                          situation={user?.data?.financialStatus}
                        />
                      )}
                    </Box>
                  )}
                  {rules.displayCashback && (
                    <Box>
                      {
                        <ChipAccumulationCashback
                          className={styles.overwriteCashbackTagStyle}
                          data={cashback.data}
                        />
                      }
                      <ChipRedemptionCashback
                        className={styles.overwriteCashbackTagStyle}
                        payWithCashback={cashback.pagar_com_cashback}
                        payWithCashbackPercentage={cashback.percentual_cashback}
                      />
                    </Box>
                  )}
                  {rules.allowsItemsQuantity && (
                    <DisplayValuesOffers.Counter
                      maxLimit={buyLimit}
                      onChange={handlePurchaseQuantity}
                    />
                  )}
                  {rules.allowsDisplayComboAnnuity && (
                    <DisplayValuesOffers.ComboAnnuity
                      onChange={onChangeComboAnnuity}
                      annuities={annuities}
                    />
                  )}
                  {rules.allowsDisplayTotalAmount && (
                    <DisplayValuesOffers.Total amount={totalAnnuity || total} />
                  )}
                  {rules.availableForPurchase && (
                    <DisplayValuesOffers.Available
                      onAddCart={() =>
                        totalAnnuity
                          ? addShoppingCart({
                              includeAnnuitiesIds: !!totalAnnuity,
                              state: "inPaymentWithAnnuity",
                            })
                          : addShoppingCart({
                              includeAnnuitiesIds: !!totalAnnuity,
                            })
                      }
                      isLoading={isLoading || isLoadingSubscribe}
                      onSubscribe={() =>
                        totalAnnuity
                          ? redirectSubscribe("inPaymentWithAnnuity")
                          : redirectSubscribe("toPayment")
                      }
                    />
                  )}
                  {rules.pendingPayment && (
                    <DisplayValuesOffers.Pending
                      onRedirect={() => goTo("my-activity#3")}
                    />
                  )}
                  {rules.shoppingCartPayment && (
                    <DisplayValuesOffers.ShoppingCart
                      onRedirect={() => goTo("shopping-cart")}
                    />
                  )}
                  {rules.paymentMade && (
                    <DisplayValuesOffers.Registered
                      onRedirect={() => goTo("my-activity#3")}
                    />
                  )}
                  {rules.courtesy && (
                    <DisplayValuesOffers.Courtesy
                      isLoading={isLoading || isLoadingSubscribe}
                      onConfirm={() => redirectSubscribe("toCourtesy")}
                      enableOnConfirm={rules.allowsDisplayCourtesy}
                    />
                  )}
                  {rules.soldOut && (
                    <DisplayValuesOffers.SoldOut
                      onWaitingList={addWaitingList}
                      isLoading={isLoading || isLoadingSubscribe}
                      enableWaitingList={rules.allowsDisplayWaitingList}
                    />
                  )}
                  {rules.enableWatchConditions && (
                    <DisplayValuesOffers.Watch
                      enableRecorded={rules.classesAvailable}
                      enableStream={rules.transmissionAvailable}
                      onWatchStream={() => actionStream(detailing)}
                      onWatchRecorded={() =>
                        goTo(`my-course/${detailing?.aga_id}`)
                      }
                    />
                  )}
                </DisplayValuesOffers.Root>
              )}
              {rules.unavailable && !isLoadingScreen && (
                <DisplayValuesOffers.Unavailable />
              )}
              {rules.enableMindsRadiologyUrl && (
                <Grid item container>
                  <Button
                    icon="link"
                    variant="midnight"
                    color="twilight"
                    onClick={() => onClickMindsRadiology()}
                    disabled={isLoading}
                  >
                    <Translator transRef="translation.Minds Radiology" />
                  </Button>
                </Grid>
              )}
              {isLoadingScreen && <DisplayValuesOffers.Loading />}
              {detailing && (
                <DisplayValuesOffers.Detail
                  endDate={endDate}
                  startDate={startDate}
                  room={detailing?.sala_atividade}
                  location={detailing?.local_atividade}
                  hourlyLoad={detailing?.carga_horaria}
                />
              )}
            </Grid>
          </Grid>
          <Divider className="detailOffer-divider" />
          <Grid className="carouselCard">
            <CarouselCardOffers
              selectOffer={selectOffer}
              selectProduct={selectProduct}
              cc={offer?.centro_custo_id_out || center_cost_id}
              id={id}
            />
          </Grid>
        </Container>
      </Grid>
    </Layout>
  );
};

export default DetailOfferView;
